<script>
  import SectionRenderer from '../components/SectionRenderer.vue';
  import sections from './sections.json';
  import { HashScrollMixin } from '@/views/app/dashboard/footer-pages/components/HashScrollMixin';

  export default {
    name: 'TNC',
    components: { SectionRenderer },
    mixins: [HashScrollMixin],
    data: () => ({
      sections,
    }),
    metaInfo() {
      return {
        title: 'Terms and Conditions',
        meta: [
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ],
      };
    },
  };
</script>
<template>
  <div class="page-container">
    <div class="page">
      <div class="content">
        <h1 class="mb-8">TERMS & CONDITIONS</h1>
        <span class="white--text">DATE OF LAST UPDATE: January 07, 2025</span>
        <p class="mt-9 mb-15">
          These Terms and Conditions form a binding legal agreement between users and the site operator and apply to
          your use of any of our Games and our Platform in any way through any electronic device (web, mobile, tablet,
          or any other device).
          <br />
          MaxQuest is a free-to-play game operator. By creating an account with MaxQuest (
          <router-link to="/" class="link">https://www.maxquest.com</router-link>
          ) or otherwise accessing and using the platform (as further defined below), you agree to comply with the Terms
          and Conditions of MQ Technology DWC-LLC, the Privacy Policy, Responsible Gaming Policy, Customer Acceptance
          Policy and other game-specific or promotion-specific terms relevant to your Participation, and all applicable
          platform or game rules that may be published, which form a legal agreement between you and MQ Technology
          DWC-LLC.
          <br />
          You must read these Terms and Conditions carefully before checking the box to indicate acceptance. If you do
          not agree or comply with any provision of these Terms and Conditions or any other linked policy, rules, or
          terms, you may not use the platform or play any game.
          <br />
          PLEASE NOTE THAT THESE TERMS AND CONDITIONS INCLUDE A PROVISION WAIVING THE RIGHT TO PURSUE ANY CLASS, GROUP,
          OR REPRESENTATIVE CLAIM AND REQUIRING YOU TO PURSUE PAST, PENDING, AND FUTURE DISPUTES BETWEEN YOU AND MQ
          TECHNOLOGY DWC-LLC THROUGH INDIVIDUAL ARBITRATION UNLESS YOU OPT-OUT WITHIN THE SPECIFIED TIME FRAME. SEE
          CLAUSE 20 FOR MORE INFORMATION
        </p>
        <section-renderer :sections="sections" />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import '../components/style.scss';

  ::v-deep {
    //#other {
    //  &:before,
    //  li:before {
    //    content: unset;
    //  }
    //
    //  h2 {
    //    display: none;
    //  }
    //}

    .content {
      & > span {
        font-weight: 600 !important;
      }
    }
  }
</style>
